import { ReduxDispatch, ReduxState } from "../../ducks/reducers";
import { connect } from "react-redux";
import React from "react";
import { RouteProps } from "react-router";
import { Typography } from "material-ui";
import { Grid } from "material-ui";
import { SetHeader } from "../../ducks/common";
import { Link } from "react-router-dom";

interface IEIdentifyErrorPageStateProps {}

interface IEIdentifyErrorPageDispatchProps {
    SetHeaderValue: (header: string) => void;
}

type IEIdentifyErrorPageProps = IEIdentifyErrorPageStateProps &
    IEIdentifyErrorPageDispatchProps &
    RouteProps;

const styles = {};

class EIdentifyErrorPage extends React.Component<IEIdentifyErrorPageProps> {
    constructor(props: IEIdentifyErrorPageProps) {
        super(props);
    }

    componentWillMount() {
        this.props.SetHeaderValue("Tunnistautuminen");
    }

    public render() {
        return (
            <div>
                <Grid item xs={12}>
                    <Typography>
                        Varmennus epäonnistui. Ole hyvä ja yritä myöhemmin
                        uudelleen.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Link to={"/"}>Palaa takaisin</Link>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IEIdentifyErrorPageDispatchProps => {
    return {
        SetHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
    };
};

export default connect(null, mapDispatchToProps)(EIdentifyErrorPage);



// WEBPACK FOOTER //
// ./src/views/eidentify/EIdentifyError.tsx